import { environment } from "../../environments/environment";

//ser4.serapp.com, ser4api.serapp.com, ser4files.serapp.com
export const API_URL = environment.apiPath;
export const SITE_URL = environment.sitePath;
export const FileManager_PATH = environment.fileManagerPath;
export const FileManager_API = environment.fileManagerAPI;



// WEBPACK FOOTER //
// ./src/app/constants/index.ts